import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement, Keywords } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import { defaultConfig } from '../config'
import { formatCurrency, currency, addTrailingZeros, getHandle } from '../helpers'

import BadgesComponent from "../serp/Product/BadgesComponent"
import VariantsWishlist from "../serp/Product/VariantsWishlist"
import Tags from "../serp/Product/Tags"

export default () => {
    const {
        response: { products, keywords },
    } = useAppState()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    const [form, setForm] = useState(screenWidth < 769 ? document.querySelector(".header__search-bar--mobile") : document.querySelector(".header__search-bar--desktop"))
    const [leftPosition, setLeftPosition] = useState(form?.getBoundingClientRect().x)

    useEffect(() => {
        if (window.innerWidth < 769) {
            setForm(document.querySelector(".header__search-bar--mobile"))
        } else {
            setForm(document.querySelector(".header__search-bar"))
        }

        if (form) {
            setLeftPosition(form.getBoundingClientRect().x)
        }
    }, [])

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth)

            if (screenWidth < 769) {
                setForm(document.querySelector(".header__search-bar--mobile"))
            } else {
                setForm(document.querySelector(".header__search-bar"))
            }

            if (form) {
                setLeftPosition(form.getBoundingClientRect().x)
            }

        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [screenWidth])

    useEffect(()=>{
        Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-autocomplete .nosto-item',
            productUrlElement: '.ns-autocomplete .nosto-product-url',
            productHandleAttribute: 'nosto-handle',
            priceElement: '.ns-autocomplete .nosto-price',
            listPriceElement: '.ns-autocomplete .nosto-listprice',

        })
    })


    return (
        <div class="ns-autocomplete ns-absolute ns-align-items-start ns-border-box ns-my-0 ns-mx-auto"
            data-nosto-element="autocomplete" style={`left: -${leftPosition}px`}>
            <div class="ns-suggestions-container ns-mt-2 ns-mt-sm-auto">
                <div class="ns-suggestions-heading ns-font-medium">Suggestions</div>
                <div class="ns-suggestions-inner">

                    {keywords?.hits?.map((hit) => {
                        return (
                            <AutocompleteElement hit={hit}>
                                <div
                                    class="ns-d-flex flex-row ns-justify-content-between ns-clickable"
                                    data-nosto-element="keyword"
                                >
                                    {
                                        hit?._highlight?.keyword
                                            ? <span dangerouslySetInnerHTML={{ __html: hit._highlight.keyword }}></span>
                                            : <span>{hit.keyword}</span>
                                    }
                                </div>
                            </AutocompleteElement>
                        )
                    })}

                </div>
            </div>
            <div class="ns-autocomplete-prods">

                <div class="ns-products-heading ns-font-medium">
                    Products
                </div>

                <div class="ns-prods-list">
                    {products?.hits?.map((hit) => {

                        const { productId, imageUrl, name, brand, price, listPrice, url, alternateImageUrls, customFields, tags1, availability, skus: { id } } = hit;

                        const license = customFields?.find(k => k.key == "custom-product_license")?.value
                        const collab = customFields?.find(k => k.key == "custom-collaboration")?.value
                        const currentColor = customFields?.find(k => k.key == "custom-color_family")?.value.replaceAll("[", "").replaceAll("]", "").replaceAll('"', "").replaceAll('&quot;', '')

                        return (
                            <AutocompleteElement hit={hit} >
                                <div class="product-card ns-product-card nosto-item" nosto-handle={getHandle(url)}>
                                    <div class="product-card__media">
                                        <div class="product-gallery__badges">

                                            {/* <BadgesComponent
                                                listPrice={listPrice}
                                                price={price}
                                                tags1={tags1}
                                                collab={collab} /> */}

                                        </div>

                                        <a href={url} class="product-card__image-wrapper" aria-hidden="true" tabindex="-1">
                                            <picture>
                                                <img
                                                    src={imageUrl?.toString()?.replace('.jpg', '_400x.jpg')?.replace('.webp', '_400x.webp')}
                                                    srcset={imageUrl?.toString()?.replace('.jpg', '_400x.jpg')?.replace('.webp', '_400x.webp')}
                                                    alt={name} class="product-card__image" loading="lazy" />

                                                {/* <Tags
                                                    customFields={customFields}
                                                    availability={availability}
                                                    tags1={tags1} /> */}

                                            </picture>
                                        </a>

                                    </div>
                                    <div class="product-card__info">
                                        <h3 class="product-card__vendor">
                                            <span class="product-card__vendor-value">{brand}</span>
                                            {collab ? (
                                                <span class="product-card__vendor-value">+ {collab}</span>
                                            ) : license && (
                                                <span class="product-card__vendor-value">+ {license}</span>
                                            )}
                                        </h3>

                                        <a href={url} class="product-card__title ns-prod-name nosto-product-url">
                                            <span class="visually-hidden">{`${name} in ${currentColor}`}</span>
                                            <span aria-hidden="true">{name}</span>
                                        </a>

                                        {price !== listPrice ? (
                                            <div class="product-info__price">
                                                <span class="product-info__price-value product-info__price-value--compare-price ns-listPrice nosto-listprice">
                                                    {/* {currency}{addTrailingZeros(listPrice)} */}
                                                </span>

                                                <span class="product-info__price-value product-info__price-value--sale nosto-price">
                                                    {/* {currency}{addTrailingZeros(price)} */}
                                                </span>
                                            </div>
                                        ) : (
                                            <div class="product-card__price">
                                                <span class="product-card__price-value nosto-price"></span>
                                            </div>
                                        )}

                                        <VariantsWishlist
                                            tags1={tags1}
                                            url={url}
                                            id={id}
                                        />

                                    </div>
                                </div>
                            </AutocompleteElement>
                        )
                    })}
                </div>

            </div>
            <div class="ns-d-flex ns-justify-content-center ns-mt-2 ns-mt-sm-5 ns-cta-container">
                <button type="submit" class="ns-act-btn ns-act-btn-outline-primary ns-d-inline-flex ns-align-items-center ns-text-align-center ns-view-all-button">
                    View all results
                </button>
            </div>
        </div>
    )
}
